import React from 'react'
import Banner from '../../Constant/Banner/Banner';

const ContactUs = () => {
   return (
     <>
       <Banner imagePath="contactBanner.png" BannerText="Contact Us" />
       <div className="container">
         <div className="py-4">
           <div className="row">
             <div className="col-lg-7 mx-auto d-flex justify-content-center flex-column">
               <h1
                 className="text-center text-primary"
                 data-aos="fade-in"
                 data-aos-offset="300"
                 data-aos-easing="ease-in-sine"
               >
                 For any type of enquiry
               </h1>
               <form
                 role="form"
                 id="contact-form"
                 method="post"
                 autoComplete="off"
               >
                 <div
                   className="card-body"
                   data-aos="zoom-in"
                   data-aos-offset="400"
                   data-aos-easing="ease-in-sine"
                 >
                   <div className="row">
                     <div className="col-md-6">
                       <label>First Name</label>
                       <div className="input-group mb-4">
                         <input
                           className="form-control"
                           placeholder=""
                           aria-label="First Name..."
                           type="text"
                         />
                       </div>
                     </div>
                     <div className="col-md-6 ps-2">
                       <label>Last Name</label>
                       <div className="input-group">
                         <input
                           type="text"
                           className="form-control"
                           placeholder=""
                           aria-label="Last Name..."
                         />
                       </div>
                     </div>
                   </div>
                   <div className="mb-4">
                     <label>Email Address</label>
                     <div className="input-group">
                       <input
                         type="email"
                         className="form-control"
                         placeholder=""
                       />
                     </div>
                   </div>
                   <div className="mb-4">
                     <label>Mobile Number</label>
                     <div className="input-group">
                       <input
                         type="tel"
                         pattern="[0-9]{10}"
                         className="form-control"
                         placeholder=""
                       />
                     </div>
                   </div>
                   <div className="mb-4">
                     <label>Upload Resume</label>
                     <div className="input-group">
                       <input
                         type="File"
                         className="form-control file-upload-button"
                         name="Upload Resume"
                       />
                     </div>
                   </div>

                   <div className="row">
                     <div className="col-md-12">
                       <button
                         type="submit"
                         className="btn bg-gradient-dark w-100"
                       >
                         Send Message
                       </button>
                     </div>
                   </div>
                 </div>
               </form>
             </div>
           </div>
         </div>
       </div>
     </>
   );
}

export default ContactUs